import { render, staticRenderFns } from "./StudentAccessHeatmap.vue?vue&type=template&id=a271b5c0&scoped=true&functional=true&"
import script from "./StudentAccessHeatmap.vue?vue&type=script&lang=js&"
export * from "./StudentAccessHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./StudentAccessHeatmap.vue?vue&type=style&index=0&id=a271b5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a271b5c0",
  null
  
)

export default component.exports